import type { TaskPriority, TaskStatus } from '@saas/shared';

import type { BadgeTone } from '@/components/Badge';
import { taskPriorityLabel, taskStatusLabel } from '@/lib/core-field-option-labels';
import type { CoreColumnTranslateFn } from '@/lib/ext-list-columns';

// Nazwy kodów: jedna ścieżka z edytorem wartości domyślnej (`lib/core-field-option-labels.ts`).
export function statusLabel(t: CoreColumnTranslateFn, status: TaskStatus): string {
  return taskStatusLabel(status, t);
}

export function priorityLabel(t: CoreColumnTranslateFn, priority: TaskPriority): string {
  return taskPriorityLabel(priority, t);
}

export const STATUS_TONE: Record<TaskStatus, BadgeTone> = {
  new: 'info',
  in_progress: 'warning',
  done: 'success',
  cancelled: 'neutral',
};

export const PRIORITY_TONE: Record<TaskPriority, BadgeTone> = {
  low: 'neutral',
  normal: 'info',
  high: 'warning',
  urgent: 'danger',
};

/** Kolory torów Kanbana — te same odcienie co plakietki statusów. */
export const STATUS_KANBAN_COLOR: Record<TaskStatus, string> = {
  new: '#3B82F6',
  in_progress: '#F59E0B',
  done: '#16A34A',
  cancelled: '#9CA3AF',
};
